import List from "@/components/list";
import { tableBaseProps } from '@/utils/common.js';
import router from "@/router";

const Table = (args) => {
  const { listeners, props } = args;
  const selectionChange = listeners["selectionChange"] || function () { };
  const del = listeners["del"] || function () { };
  const submit = listeners["submit"] || function () { };
  const toEdit = listeners["toEdit"] || function () { };
  const cancel = listeners["cancel"] || function () { };
  const toResPage = listeners["toResPage"] || function () { };
  const goDetail = listeners["goDetail"] || function () { };
  const auditDetail = listeners["auditDetail"] || function () { };

  // declareClassPlan/material
  //  {paramKey: "0", paramValue: "审核中"}
  //  {paramKey: "1", paramValue: "审核通过"}
  //  {paramKey: "2", paramValue: "审核不通过"}
  //  {paramKey: "5", paramValue: "待送审"}
  const canDel = [5];
  const canEdit = [5, 2];
  const canSubmit = [5, 2];
  const canCancel = [0]
  const canLookRes = [1];

  const Deal = ({ props: { vo } }) => {
    const { row } = vo;
    const auditStatus = Number(row.auditStatus)
    const dealConf = [];
    const editFlag = canEdit.includes(auditStatus)
    const delFlag = canDel.includes(auditStatus)
    const submitFlag = canSubmit.includes(auditStatus)
    const cancelFlag = canCancel.includes(auditStatus)
    const resFlag = canLookRes.includes(auditStatus)
    const detailFlag = Number(row.auditNum) > 0

    dealConf.push([
      editFlag ? "icon-edit" : "icon-edit-disable",
      "编辑",
      () => {
        editFlag && toEdit(row)
      },
      "classReportPlan:update"
    ])

    dealConf.push([
      delFlag ? "icon-delete" : "icon-delete-disable",
      "删除",
      () => {
        delFlag && del(row)
      },
      "classReportPlan:delete"
    ]);

    if (submitFlag) {
      dealConf.push([
        "icon_review",
        "送审",
        () => submit(row),
        "classReportPlan:Audit"
      ]);
    } else {
      dealConf.push([cancelFlag ? "icon-delete-group" : "icon-delete-group-disable", "取消送审", () => {
        cancelFlag && cancel(row);
      }, "classReportPlan:cancelAudit"]);
    }

    dealConf.push([
      detailFlag ? "icon-diaodong" : "icon-diaodong-disable",
      "审核详情",
      () => {
        detailFlag && auditDetail(row)
      },
      "classReportPlan:Audit:list"
    ]);

    dealConf.push([
      resFlag ? "icon-resource-config"
        : "icon-resource-config-disabled",
      "办班资料",
      () => {
        resFlag && toResPage(row)
      },
      "classReportPlanFileLibrary:page"
    ]);


    return (
      <div class="deal-group">
        {dealConf.map(item => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  }

  const ClassName = ({ props: { vo } }) => {
    const row = vo.row;
    return (
      <div class="base-hover-char ellipsis--l3" onClick={() => goDetail(row)}>
        {row.className}
      </div>
    );
  };

  const DescThree = ({ props: { vo, value } }) => {
    const row = vo.row;
    const content = row[value];
    return (
      <div class="ellipsis--l3" title={content}>
        {content}
      </div>
    )
  }

  const AccountTableConfig = [
    {
      type: "selection",
      label: "main",
    },
    {
      ...tableBaseProps("班级名称", "className", "m220"),
      render: (vo) => <ClassName vo={vo} />,
    },
    {
      ...tableBaseProps("培训内容", "desc", "m220"),
      render: (vo) => <DescThree vo={vo} value='desc' />,
    },
    {
      ...tableBaseProps("培训对象", "trainPerson", "m220"),
      render: (vo) => <DescThree vo={vo} value='trainPerson' />,
    },
    tableBaseProps("调训人数", "trainNum", "m100"),
    tableBaseProps("培训时间", "trainTime", "m120"),
    tableBaseProps("申报部门", "reportDeptName", "m120"),
    tableBaseProps("提交人", "auditUserName", "100"),
    tableBaseProps("审核状态", "auditStatusName", "100"),
    tableBaseProps("更新时间", "modifyDate", "150"),
    {
      label: "操作",
      fixed: "right",
      width: '130',
      render: vo => <Deal vo={vo} />
    }

  ]
  return <List {...args} talbeCols={AccountTableConfig} onSelectionChange={selectionChange} />;
}
export default Table;
